import { useCallback } from 'react';
import { useMutation } from '@ts-core/lib/apollo';
import { useIntl } from 'react-intl';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { UpdateProfileInput } from '../types/Auth';

import { updateProfileMutation, UpdateProfileMutationResult, UpdateProfileMutationVariables } from '../graphql/mutations/updateProfileMutation';

export interface ProfileActionsHookPayload {
  onUpdateProfile: (input: UpdateProfileInput) => void;

  updateProfileLoading: boolean;
  updateProfileError?: string;
}

export default function useProfileActions(): ProfileActionsHookPayload {
  const intl = useIntl();
  const { showSuccessNotification } = useSnackbarNotifications();

  const [updateProfile, { loading: updateProfileLoading, error: updateProfileError }] = useMutation<
    UpdateProfileMutationResult,
    UpdateProfileMutationVariables
  >(updateProfileMutation, {
    onCompleted: () => showSuccessNotification(intl.formatMessage({ id: 'profile.update.successMessage' })),
  });
  const onUpdateProfile = useCallback(
    (input: UpdateProfileInput) => {
      updateProfile({ variables: { input } });
    },
    [updateProfile]
  );

  return {
    onUpdateProfile,
    updateProfileLoading,
    updateProfileError: getErrorMessage({ error: updateProfileError }),
  };
}
